import { newReleases } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

export default function NewReleases() {
  return (
    <section id="new-releases" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="新片速递"
          title="最近上线的作品，值得先看一眼"
          description="新片不急着追，但可以先了解它在讲什么。下面按时间整理近期上线的作品与第一印象，方便你判断要不要加入待看清单。"
        />

        <ol className="mt-10 space-y-4">
          {newReleases.map((item) => (
            <li
              key={item.title}
              className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-5 sm:flex-row sm:items-center md:p-6"
            >
              <div className="flex items-center gap-4 sm:w-40 sm:shrink-0 sm:flex-col sm:items-start sm:gap-2">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-calendar-event-line text-lg"></i>
                </span>
                <span className="font-heading text-sm font-semibold text-foreground-900">
                  {item.date}
                </span>
              </div>

              <div className="min-w-0 flex-1 sm:border-l sm:border-background-200 sm:pl-6">
                <div className="flex flex-wrap items-center gap-3">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">
                    {item.title}
                  </h3>
                  <span className="rounded-full bg-primary-100 px-2.5 py-0.5 font-label text-[11px] font-medium text-primary-800">
                    {item.tag}
                  </span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {item.note}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}